import React, { createContext, useContext, useState } from 'react';

const HelpContext = createContext();

export const useHelp = () => {
  const context = useContext(HelpContext);
  if (!context) {
    throw new Error('useHelp must be used within a HelpProvider');
  }
  return context;
};

export const HelpProvider = ({ children }) => {
  const [activeHelpModal, setActiveHelpModal] = useState(null);

  const showHelp = (modalType) => {
    setActiveHelpModal(modalType);
  };

  const hideHelp = () => {
    setActiveHelpModal(null);
  };

  return (
    <HelpContext.Provider
      value={{
        activeHelpModal,
        showHelp,
        hideHelp,
      }}
    >
      {children}
    </HelpContext.Provider>
  );
};
